module.exports = __webpack_public_path__ + "static/img/ky.0136da61.svg";